export default __webpack_public_path__ + "static/media/o13.b2d65430.jpg";